import { jsx } from "react/jsx-runtime";
import classNames from "classnames";
import { useFocus } from "../../hooks/use-focus.js";
import styles from "./fieldset.module.scss";
const Fieldset = ({
  id,
  ariaLabelledBy,
  ariaDescribedBy,
  required,
  className,
  onBlur,
  onFocus,
  ...rest
}) => {
  const { handleFocus, handleBlur, containerRef } = useFocus({
    onBlur,
    onFocus
  });
  const labelledBy = [ariaLabelledBy, ariaDescribedBy].filter(Boolean).join(" ");
  return /* @__PURE__ */ jsx(
    "fieldset",
    {
      ref: containerRef,
      id,
      "aria-labelledby": labelledBy,
      "aria-required": required,
      className: classNames(styles.fieldset, className),
      onBlur: handleBlur,
      onFocus: handleFocus,
      ...rest
    }
  );
};
export {
  Fieldset
};
//# sourceMappingURL=fieldset.js.map
